<template>
  <el-container class="box">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
    </div>
    <el-main class="content" v-loading = 'submitLoad'>
      <el-form ref="form" @submit.native.prevent :model="form" label-width="150px" :rules="rules">
        <el-form-item label="机构选择：" prop="hospitalId"> 
          <el-select v-model="form.hospitalId" filterable placeholder="请选择目前机构" :disabled="editFlagStatus" size="small"
            class="f-input" @change="hospitalChange">
            <el-option v-for="(item, index) in hospitalList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- :disabled="editFlagStatus" -->
        <el-form-item label="线下科室选择：" prop="openDepartmentIdList">
          <el-cascader filterable placeholder="请选择目前机构已有的科室" class="f-input" size="small"
            v-model="form.openDepartmentIdList" :options="departmentList" :props="labelProps" :disabled="editFlagStatus"
            @change="openDepartmentChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="科室病种配置：" prop="diseaseId" class="editor-w">
            <el-select v-model="form.diseaseId" filterable placeholder="请选择科室病种" value-key="id" size="small"
              class="f-input" :disabled="editFlagStatus" @change="diseaseChange">
              <el-option v-for="(item, index) in diseaseTypeList" :disabled='item.focusFieldFlag' :key="index" :label="item.suborderName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="医生列表：" class="editor-w">
          <el-button type="primary" size="small" :disabled="!edit" @click="viewDoctorList()">查看医生列表</el-button>
        </el-form-item>
        <div v-if="form.diseaseId">
          <!-- <el-form-item label="重点关注指标设置：" prop="groupId" > -->
          <el-form-item label="重点关注指标设置：">
            <KeyField  ref="child" :oldList="dataList" :allOldList="dataListDelete" :diseaseId="this.form.diseaseId"
              :openDepartmentId="this.form.openDepartmentId" :openDepartmentParentId="this.form.openDepartmentParentId" :diseaseName="diseaseName"
              :hospitalId="form.hospitalId" :statusType="statusType"  :bigStatus="bigStatus" @confimClick="confimClick"></KeyField>
          </el-form-item>
        </div>
        <div class="btn-box">
          <el-button type="primary" size="small" v-preventReClick @click="saveClick('form')">保存</el-button>
        </div>
      </el-form>
    </el-main>
    <DoctorList v-if="showListDialog" :centerDialogVisible.sync="showListDialog" :diseaseTypeProps="diseaseTypeProps"
      :diseaseId="form.openDepartmentId" />
  </el-container>
</template>

<script>
import { 
  pageForDepartmentDetail,
  saveConfig,
  updateConfig,
  getListByHospitalId
} from "./api";
import {
  departHospitalList,
  findDiseaseTypeByother,
  findDiseaseType
} from "./departmentHomePage/api/index";
import { plateFormOn } from "@/api/acc.js";
import KeyField from "./components/KeyField.vue";
import DoctorList from "./departmentHomePage/components/doctorList";
export default {
  components: { KeyField, DoctorList },
  props: {},
  data() {
    return {
      submitLoad:false,
      breadList: [{ name: "机构组织" }, { name: "资料配置" }],
      paramData: {
        hospitalId: "", //线下机构
        openDepartmentName: "", //线下科室名称
        openDepartmentId: "" //线下科室
      },
      rules: {
        hospitalId: [
          { required: true, message: "请选择机构", trigger: "change" }
        ],
        openDepartmentIdList: [
          { required: true, message: "请选择线下科室", trigger: "change" }
        ],
        diseaseId: [
          { required: true, message: "请选择科室病种", trigger: "change" }
        ]
      }, 
      openDepartmentList: [], //线下科室选择
      setKesDept: {
        value: "id",
        label: "name",
        children: "children",
        disabled: "value",
        emitPath: false
      },

      hospitalList: [], //机构选择
      departmentList: [], //科室选择
      diseaseTypeList: [], //科室病种配置
      selectDisabled: false,
      form: {
        hospitalId: "", //机构ID
        openDepartmentId: "", //科室ID
        openDepartmentParentId: "", //科室ID
        // departmentIntroduction: "", //科室介绍
        diseaseId: null,
        configType: "department",
        id: null,
        openDepartmentIdList: [],
        diseaseName: null
      },
      showListDialog: false, //查看医生列表
      labelProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      edit: true,
      editFlagStatus: false,
      value: "",
      dataList: [], //重点指标列表
      dataListDelete: [], //重点指标列表
      dataListGroup: [], //重点指标列表
      diseaseId: null, //病种id
      diseaseTypeListArr: [],
      statusType: "department",
      bigStatus:true,
      diseaseName:null,
    };
  },
  watch: {},
  computed: {},
  created() { 
    if (this.$route.query.id) {
      //编辑
      this.editFlagStatus = true;
      this.form.id = this.$route.query.id;
      this.pageForDepartmentDetailRequest().then(res => {
        this.form.hospitalId = res.data.hospitalId;
      });
    }
    this.getHospital();  
  },
  mounted() {},
  methods: {
    pageForDepartmentDetailRequest() { 
      return new Promise((resolve, reject) => {
        pageForDepartmentDetail({
          id: this.$route.query.id
        }).then(res => {
          if (res.code == 0) {
            if (res.data) {
              resolve(res);
              this.form.hospitalId = res.data.hospitalId; 
              this.form.openDepartmentId = res.data.openDepartmentId;
              this.form.diseaseName = res.data.diseaseName;
              this.diseaseName = res.data.diseaseName;
              this.form.openDepartmentParentId = res.data.openDepartmentParentId;
              getListByHospitalId({ hospitalId: res.data.hospitalId }).then(
                end => {
                  if (res.code == 0) {
                    this.departmentList = end.data;  
                    if (
                      res.data.openDepartmentParentId !=
                      res.data.openDepartmentId
                    ) {
                      this.form.openDepartmentIdList.push(
                        res.data.openDepartmentParentId
                      );
                      this.form.openDepartmentIdList.push(
                        res.data.openDepartmentId
                      );
                    } else {
                      this.form.openDepartmentIdList.push(
                        res.data.openDepartmentId
                      );
                    } 
                    this.getDiseaseType()
                  }
                }
              ); 
              this.form.diseaseId = res.data.diseaseId;
              if (res.data.focusFieldConfigDetailList.length > 0) {
                // let end = JSON.parse(
                //   JSON.stringify(res.data.focusFieldConfigDetailList)
                // ); 
                this.dataList = JSON.parse(
                  JSON.stringify(res.data.focusFieldConfigDetailList)
                );
                this.dataList = this.dataList.map((item,index) => {
                  return {
                    ...item,
                    itemIndex:index,
                  }
                })
                this.dataListDelete = JSON.parse(
                  JSON.stringify(res.data.focusFieldConfigDetailList)
                );
                this.dataListDelete = this.dataListDelete.map((item,index) => {
                  return {
                    ...item,
                    itemIndex:index,
                  }
                })
                this.form.focusFieldConfigDetailList = JSON.parse(
                  JSON.stringify(res.data.focusFieldConfigDetailList)
                );
                this.form.focusFieldConfigDetailList = this.form.focusFieldConfigDetailList.map((item,index) => {
                  return {
                    ...item,
                    itemIndex:index,
                  }
                })
              } else {
                this.dataList = [];
                this.dataListDelete = [];
                this.form.focusFieldConfigDetailList = [];
              }
            }
          } else {
            reject();
          }
        });
      });
    }, 
    openDepartmentChange(val) { 
      this.dataList = [];
      this.dataListDelete = [];
      this.form.focusFieldConfigDetailList = []
      if (val.length > 1) {
        this.form.openDepartmentId = val[val.length - 1];
        this.form.openDepartmentParentId = val[val.length - 2];
      } else {
        this.form.openDepartmentId = val[val.length - 1];
        this.form.openDepartmentParentId = val[val.length - 1];
      } 
      this.form.diseaseId = null;  
      this.getDiseaseType()
    }, 
    //获取医院数据
    getHospital() {
      departHospitalList({ keyword: "" }).then(res => {
        if (res.code == 0) {
          this.hospitalList = res.data 
        }
      });
    },
    //选中医院
    hospitalChange() { 
      this.dataList = [];
      this.dataListDelete = [];
      this.form.openDepartmentIdList = [];
      this.form.diseaseId = null;  
      getListByHospitalId({ hospitalId: this.form.hospitalId }).then(res => {
        if (res.code == 0) {
          this.departmentList = res.data;
        }
      });
    },
    //获取病种
    getDiseaseType() { 
      let param = {
        hospitalId:this.form.hospitalId,
        openDepartmentId:this.form.openDepartmentId,
        configType: "department"
      }  
      findDiseaseTypeByother(param).then(res => {
        if (res.code == 0) {
          if (res.data && res.data.length > 0) {
            this.diseaseTypeList = res.data;
          } else {
            this.diseaseTypeList = [];
          }
        }
      });
    },
    delLabel(item, index) {
      this.form.diseaseTypeList.splice(index, 1);
    },
    //查看医生列表
    viewDoctorList() { 
      if (!this.form.openDepartmentId) {
        this.$message.error("请先选择线下科室");
        return;
      }
      if (this.form.diseaseId == null) {
        this.$message.error("请先选择科室病种");
        return;
      } 
      this.diseaseTypeListArr = this.diseaseTypeList.filter(item => {
        return this.form.diseaseId == item.id;
      }); 
      this.diseaseTypeProps = this.diseaseTypeListArr.map(item => {
        return {
          diseaseTypeId: item.id,
          diseaseTypeName: item.suborderName
        };
      }); 
      this.showListDialog = true;
    },
    saveClick(form) {
      this.$refs[form].validate(valid => {
        if (valid) { 
          this.submitLoad = true
          if (this.editFlagStatus) {
            updateConfig({
              ...this.form
            }).then(res => { 
              this.$message.success("编辑成功");
              this.$router.push({
                path: "/Organization/dataConfigurationList"
              });
            }).catch(err=>{
              this.submitLoad = false
            });
          } else {
            saveConfig({
              ...this.form
            }).then(res => {
              this.$message.success("新增成功");
              this.$router.push({
                path: "/Organization/dataConfigurationList"
              });
            }).catch(err=>{
               this.submitLoad = false
            });
          }
        } else {
          return false;
        }
      });
    },
    confimClick(list) {   
      this.form.focusFieldConfigDetailList = list;
    },
    diseaseChange(e) { 
      this.dataList = [];
      this.dataListDelete = [];
      this.form.focusFieldConfigDetailList = []
      this.diseaseTypeListArr = this.diseaseTypeList.filter(item => {
        return e == item.id;
      });
      this.form.diseaseName = this.diseaseTypeListArr[0].suborderName; 
      this.diseaseName = this.diseaseTypeListArr[0].suborderName; 
      console.log(this.diseaseName,"this.diseaseName");
    }
  }
};
</script>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.content {
  margin: 0;
  padding: 10px 20px;
  background: #fff;
}
.disease-label {
  .list {
    list-style: none;
    display: flex;
    margin-top: 10px;
    flex-wrap: wrap;

    .lable-item {
      transition: transform 0.3s;
      cursor: move;
      width: 131px;
      height: 35px;
      display: flex;
      align-items: center;
      padding: 7px 10px 7px 15px;
      background-color: #eff6ff;
      border-radius: 18px;
      justify-content: space-between;
      margin-right: 10px;
      margin-top: 10px;

      .left-text {
        color: #1a7bfc;
        font-size: 12px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }

      .right-icon {
        color: #1a7bfc;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
}
/deep/.el-form-item__content .f-input {
  width: 30%;
}
/deep/.el-form-item .el-form-item {
  margin-bottom: 20px !important;
}
.btn-box {
  text-align: center;
}
// /deep/.el-table__body-wrapper {
//   height: auto !important;
// }
</style>